const LoginPage = '/login',
  SignupPage = `/signup`,
  ForgotPasswordPage = `/forgot`,
  ResetPasswordPage = `/reset`,
  SSOLoginPage = `/login/sso`;

export default {
  LoginPage,
  SignupPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  SSOLoginPage,
};
